import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useLanguage } from '../contexts/LanguageContext';

function Q02Page() {
  const navigate = useNavigate();
  const { language, setLanguage } = useLanguage();
  const [buttonPosition, setButtonPosition] = useState({ x: 50, y: 50 });
  const [buttonScale, setButtonScale] = useState(1);
  const [buttonRotation, setButtonRotation] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const getRandomPosition = (min: number, max: number) => {
    return Math.random() * (max - min) + min;
  };

  const moveButton = (clientX: number, clientY: number) => {
    const container = document.querySelector('.buttons');
    if (!container) return;

    const rect = container.getBoundingClientRect();
    const touchPoint = { x: clientX - rect.left, y: clientY - rect.top };
    const buttonWidth = 150;
    const buttonHeight = 50;

    // Вычисляем расстояние от точки касания до кнопки
    const distance = Math.sqrt(
      Math.pow(touchPoint.x - buttonPosition.x, 2) + 
      Math.pow(touchPoint.y - buttonPosition.y, 2)
    );

    // Увеличиваем зону чувствительности
    const isClose = distance < 200;

    let newX, newY;
    if (isClose) {
      // Более резкие прыжки в случайном направлении
      const angle = Math.random() * Math.PI * 2;
      const jumpDistance = getRandomPosition(200, 400);
      
      newX = buttonPosition.x + Math.cos(angle) * jumpDistance;
      newY = buttonPosition.y + Math.sin(angle) * jumpDistance;
      
      // Отражение от стенок контейнера
      if (newX < 0) newX = rect.width - buttonWidth;
      if (newX > rect.width - buttonWidth) newX = 0;
      if (newY < 0) newY = rect.height - buttonHeight;
      if (newY > rect.height - buttonHeight) newY = 0;
    } else {
      // Случайное движение когда курсор далеко
      newX = getRandomPosition(0, rect.width - buttonWidth);
      newY = getRandomPosition(0, rect.height - buttonHeight);
    }

    // Более агрессивное изменение размера
    const newScale = isClose ? 
      getRandomPosition(0.5, 1.5) : 
      getRandomPosition(0.8, 1.2);

    // Случайный поворот
    const newRotation = getRandomPosition(-45, 45);

    setButtonScale(newScale);
    setButtonRotation(newRotation);
    setButtonPosition({ x: newX, y: newY });
  };

  const handleInteraction = (event: React.MouseEvent | React.TouchEvent) => {
    let clientX, clientY;
    
    if ('touches' in event) {
      clientX = event.touches[0].clientX;
      clientY = event.touches[0].clientY;
    } else {
      clientX = event.clientX;
      clientY = event.clientY;
    }
    
    moveButton(clientX, clientY);
    event.preventDefault();
  };

  return (
    <div className="App">
      <Header />

      <main className="main-content">
        <LanguageSwitcher language={language} setLanguage={setLanguage} />
        <img src="/screen.png" className="mascot" alt="Mascot" />
        
        <h1 className="question">
          {language === 'ru' ? 'Вам понравилось обслуживание?' : 'Қызмет көрсету ұнады ма?'}
        </h1>

        <div 
          className="buttons" 
          style={{ 
            position: 'relative', 
            minHeight: isMobile ? '500px' : '400px',
            touchAction: 'none'
          }}
          onTouchStart={handleInteraction}
          onTouchMove={handleInteraction}
          onMouseMove={!isMobile ? handleInteraction : undefined}
        >
          <button className="button primary">
            {language === 'ru' ? 'Все отлично!' : 'Бәрі керемет!'}
          </button>
          <button 
            className="button secondary"
            style={{
              position: 'absolute',
              left: `${buttonPosition.x}px`,
              top: `${buttonPosition.y}px`,
              transition: 'all 0.1s ease-out',
              transform: `scale(${buttonScale}) rotate(${buttonRotation}deg)`,
              touchAction: 'none',
              zIndex: 100
            }}

        >
            {language === 'ru' ? 'Есть претензия' : 'Шағым бар'}
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Q02Page; 